// @flow
import * as React from 'react';
import type { FC } from 'react';

type Props = {
  logo?: string;
  icon?: JSX.Element;
  label: string;
  value: string | number;
  color: string;
};

export const Card = React.forwardRef<HTMLDivElement, Props>(
  ({ logo, icon, value, color, label }, ref) => {
    return (
      <div
        ref={ref}
        className="relative p-4 overflow-hidden border rounded-lg shadow-md"
      >
        <div
          style={{ backgroundColor: color }}
          className="absolute inset-0 rounded-lg opacity-[0.08] pointer-events-none"
        />

        <div className="flex items-center">
          {icon ? (
            <div
              style={{
                color,
                backgroundColor: color ? `${color}40` : undefined,
              }}
              className="flex items-center justify-center w-8 h-8 rounded-full"
            >
              {icon}
            </div>
          ) : (
            logo && <img className="h-[35px]" src={logo} alt={label} />
          )}
        </div>

        <p style={{ color }} className="my-6 text-base font-bold">
          {label}
        </p>
        <p style={{ color }} className="text-4xl font-bold">
          {value}
        </p>
      </div>
    );
  },
);

Card.displayName = 'Card';
